import axios from "axios";
import toast from "react-hot-toast";
import {
  detectDeviceType,
  getApiCallHostPath,
  getApiCallLocalPath,
  toastErrorMessageStyle
} from "../../utils/apiCallFunction";
import { getApiCallHeadersData } from "../../utils/storageFunction";

export const DASHBOARD_CONFIG_APP_DATA = "DASHBOARD_CONFIG_APP_DATA";
export const DASHBOARD_CONFIG_ORG_DATA = "DASHBOARD_CONFIG_ORG_DATA";
export const DASHBOARD_APPS_LIST_DATA = "DASHBOARD_APPS_LIST_DATA";
export const WORKFLOW_APP_OBJECT_DATA = "WORKFLOW_APP_OBJECT_DATA";
export const ACTION_JOB_RES_DATA = "ACTION_JOB_RES_DATA";
export const ERROR_SHOW = "ERROR_SHOW";
export const NOTIFICATIONS_ARRAY = "NOTIFICATIONS_ARRAY";
export const DASHBOARD_PUBLIC_APPS_LIST_DATA = "DASHBOARD_PUBLIC_APPS_LIST_DATA";
export const DASHBOARD_EXTERNAL_APPS_LIST_DATA = "DASHBOARD_EXTERNAL_APPS_LIST_DATA";

export const setWorkflowAppObjectData = (payload) => ({
  type: WORKFLOW_APP_OBJECT_DATA,
  payload
});

export const setDashboardAppConfig = (payload) => ({
  type: DASHBOARD_CONFIG_APP_DATA,
  payload
});

export const setDashboardAppsList = (payload) => ({
  type: DASHBOARD_APPS_LIST_DATA,
  payload
});

export const setDashboardPublicAppsList = (payload) => ({
  type: DASHBOARD_PUBLIC_APPS_LIST_DATA,
  payload
});

export const setDashboardExternalAppsList = (payload) => ({
  type: DASHBOARD_EXTERNAL_APPS_LIST_DATA,
  payload
});

export const setNotificationsFunction = (payload) => ({
  type: NOTIFICATIONS_ARRAY,
  payload
});

export const setDashboardOrganizationConfig = (payload) => ({
  type: DASHBOARD_CONFIG_ORG_DATA,
  payload
});

export const setActionJobResData = (payload) => ({
  type: ACTION_JOB_RES_DATA,
  payload
});

export const setErrorShow = (payload) => ({
  type: ERROR_SHOW,
  payload
});

export const getAppsListFunction = () => async (dispatch) => {
  try {
    let { data } = await axios.get(`${getApiCallHostPath()}/api/v1/applist`, {
      headers: { ...getApiCallHeadersData() }
    });
    dispatch(setDashboardAppsList(data?.app_list || []));
    dispatch(setDashboardExternalAppsList(data?.external_apps || []));
  } catch (error) {
    toast.error(
      error.response?.data?.message || error.response?.data.error || "App not found",
      toastErrorMessageStyle()
    );
    // window.open("/page404", "_self");
    // window.history.back();
  }
};
export const getAppsListForPublicScreensFunction = () => async (dispatch) => {
  try {
    let device_type = detectDeviceType();
    let { data } = await axios.get(
      `${getApiCallHostPath()}/api/v1/guest/applist?device=${device_type === "Desktop" ? "desktop" : "mobile"}`,
      {
        // headers: getApiCallHeadersData()
      }
    );
    const newStructuredApplist = newAppListConfig(data?.app_list || []);
    dispatch(setDashboardPublicAppsList(newStructuredApplist));
  } catch (error) {
    toast.error(
      error.response?.data?.message || error.response?.data.error || "App not found",
      toastErrorMessageStyle()
    );
    // window.open("/page404", "_self");
    // window.history.back();
  }
};

export const getNotificationsCountFunction = () => async () => {
  try {
    let { data } = await axios.get(`${getApiCallLocalPath()}api/v1/todo/notificationCount`, {
      headers: getApiCallHeadersData()
    });

    return data.data;
  } catch (error) {
    return 0;
  }
};

const newAppListConfig = (appList) => {
  const newAppList = [];
  for (let app of appList) {
    let duplicateApp = JSON.parse(JSON.stringify(app));
    let public_screens = duplicateApp?.public_screens || [];
    let new_public_screens = [];
    for (let eachScreen of public_screens) {
      if (typeof eachScreen === "string") {
        new_public_screens.push(eachScreen);
      } else if (typeof eachScreen === "object" && eachScreen?.name) {
        new_public_screens.push(eachScreen?.name);
      }
    }
    duplicateApp.public_screens = new_public_screens;
    newAppList.push(duplicateApp);
  }

  return newAppList;
};
